import { ProductPromotionItemViewModel } from '@api/v3';
import { CampaignBannerViewModel } from '@api/models/CampaignBannerViewModel';
import { CategoryPromotionItemViewModel } from '@api/models/CategoryPromotionItemViewModel';
import {
  ILandingCardProps,
  LandingCardType,
} from '@components/cards/LandingCard/LandingCard';

import { CategoryCardInfo } from '../landing/components/category-promotion/CategoryPromotion';

export const formatCategoryPromotion = (
  items: Array<CategoryPromotionItemViewModel>,
  isDesktop: boolean
) =>
  items?.map(
    (t): CategoryCardInfo => ({
      title: t.name || '',
      price: t.price,
      subText: t.priceSubText,
      src:
        (!isDesktop && t.responsiveImages?.[0]?.url
          ? t.responsiveImages?.[0]?.url
          : t.images?.[0]?.url) || '',
      alt: t?.images?.[0]?.alt || '',
      link: t.url || '/',
    })
  );

export const formatProductPromotion = (
  items: ProductPromotionItemViewModel[] = [],
  isDesktop: boolean
) => {
  return items?.map(
    (t: ProductPromotionItemViewModel, i: number): ILandingCardProps => {
      const image =
        !isDesktop && t.responsiveImages?.[0]?.url
          ? t.responsiveImages?.[0]
          : t.images?.[0];

      return {
        src: image?.url || '',
        alt: image?.alt,
        cardType: i > 0 ? LandingCardType.SMALL_CARD : LandingCardType.BIG_CARD,
        info: {
          price: t.price || 0,
          discount: t.discount || 0,
          location: t.city || '',
          name: t.title,
          link: t.url || '/',
          productId: +t.id,
          duration: t.days ? `${t.days} gün` : '',
          boardType: t.boardType || '',
        },
      };
    }
  );
};

export const formatToCampaignsBannerData = (
  data: CampaignBannerViewModel | undefined,
  isDesktop: boolean
) => ({
  id: data?.id || '',
  mainText: data?.title || '',
  secondText: data?.boldTitle || '',
  description: data?.subText || '',
  link: data?.link[0]?.href || '/',
  imgSrc:
    (!isDesktop && data?.responsiveImages[0]?.url
      ? data?.responsiveImages[0]?.url
      : data?.images[0]?.url) || '',
  alt: data?.images?.[0]?.alt || '',
  styles: {},
});
